import { VIEWER_REPORT_BOOKING_MODEL_LIST, VIEWER_REPORT_BOOKING_SEARCH, VIEWER_REPORT_BOOKING_PAGINATION, VIEWER_REPORT_BOOKING_DROP_DOWN_SEARCH_TYPE } from './actionType'

export const setModelDeviceListToState = (payload) => ({
    type: VIEWER_REPORT_BOOKING_MODEL_LIST,
    payload
})

export const setSearchToState = (payload) => ({
    type: VIEWER_REPORT_BOOKING_SEARCH,
    payload
})
export const setPaginationToState = (payload) => ({
    type: VIEWER_REPORT_BOOKING_PAGINATION,
    payload
})
export const setDropDownSearchType = (payload) => ({
    type: VIEWER_REPORT_BOOKING_DROP_DOWN_SEARCH_TYPE,
    payload
})